// extracted by mini-css-extract-plugin
export default {"label":"SquareLabel_label__0Y7ch"};